import React from "react";

import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import SequentialIcon from './icons/SequentialIcon'
import Parallel from '@material-ui/icons/PauseOutlined';


import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  Tooltip,
} from "@material-ui/core";

import { AuditLogType } from "../enum";
const formatDuration = (milliseconds) => {
  return `${Number(milliseconds) / (1000 * 60 * 60)}h`;
};

const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  return date.toLocaleDateString(); // shorter format
};

const groupByProcessId = (logs) => {
  const groups = {};
  logs.forEach((log) => {
    const processId = log?.data?.process?._id;
    const orderId = log?.data?._id;
    if (processId) {
      if (!groups[processId]) {
        groups[processId] = [];
      }
      groups[processId].push(log);
    } else if (orderId) {
      if (!groups[orderId]) {
        groups[orderId] = [];
      }
      groups[orderId].push(log);
    }
  });
  return groups;
};



const buildValueComponent = (log) => {
  if (!log?.data) return "-";
  const data = log?.data;

  if (data?.process) {
    const process_date = data.process_date ? formatDate(data?.process_date) : "";
    const end_date = data.end_date ? formatDate(data?.end_date) : "";
    
    const parallel = data.should_occur_parallel 
    ? (
      <>
        <Parallel style={{paddingTop: 10}}/> Parallel
      </>
    ) : (
      <>
         <SequentialIcon/> Sequential
      </>
    );

    const locked = data?.is_detached
      ? (
        <>
          <LockOpenIcon style={{ fontSize: 16, color: 'black', verticalAlign: 'middle' }} /> Unlocked
        </>
      ) : (
        <>
          <LockIcon style={{ fontSize: 16, color: 'black', verticalAlign: 'middle' }} /> Locked
        </>
      ) 

    const duration = data?.actual_duration
      ? formatDuration(data?.actual_duration)
      : "-";

    return (
      <span>
        {process_date}–{end_date}, {duration}, {parallel}, {locked}
      </span>
    );
  } else {
    return log.message;
  }
};



export const OrderLogViewer = ({ item }) => {
  if (!item) {
    return null;
  }
  const groupedLogs = groupByProcessId(item.logs);

  return (
    <Box >
      <Typography variant="h5" gutterBottom>
        Order Log Snapshot
      </Typography>
      <Typography variant="body1">
        <strong>Order ID:</strong> {item.linked_object_id}
      </Typography>
      <Typography variant="body1">
        <strong>Action:</strong> {item.action}
      </Typography>
      <Typography variant="body1">
        <strong>Message:</strong> {item.message}
      </Typography>

      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          Processes
        </Typography>
        <Divider />
        <Box mt={2}>
          <TableContainer component={Paper} >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Process</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Before Value</strong>
                  </TableCell>
                  <TableCell>
                    <strong>After Value</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(groupedLogs).map(([processId, logs]) => {
                  const beforeLog = logs.find(
                    (log) =>
                      log.type === AuditLogType.Before ||
                      log.type === AuditLogType.Info
                  );
                  const afterLog = logs.find(
                    (log) => log.type === AuditLogType.After
                  );
                  return (
                    <TableRow key={processId}>
                      <TableCell>
                        {beforeLog?.data?.process?.name ||
                          afterLog?.data?.process?.name ||
                          "General"}
                      </TableCell>
                      <Tooltip title={beforeLog.message}>
                        <TableCell>{buildValueComponent(beforeLog)}</TableCell>
                      </Tooltip>
                      <Tooltip title={beforeLog.message}>
                        <TableCell>{buildValueComponent(afterLog)}</TableCell>
                      </Tooltip>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default OrderLogViewer;
